import { I18n } from '@calendly/i18n'

import { Summary } from './summary'
import { AccordionPanel } from '../../../components/accordion'
import { LimitsAndBuffers } from '../../components/limits_and_buffers'

export const LimitsAndBuffersPanel = ({ isLocked, ...props }) => (
  <AccordionPanel
    titleId="limits-and-buffers-label"
    title={I18n.t('publisher.event_type_editor.sections.more_options.limits_and_buffers.title')}
    subheader={<Summary />}
    {...props}
  >
    <LimitsAndBuffers isLocked={isLocked} />
  </AccordionPanel>
)
